import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';

const dictPrefix = 'financialPortal.settings.status';

/**
 * Activo es la parametrización que rige hoy; todo lo demás — lo ya superado y
 * lo programado a futuro — es Inactivo. Colores del catálogo de la pantalla:
 * verde #CEF0DA y gris #CCCCCC.
 */
export function StatusBadge({ isActive }: { isActive: boolean }) {
  const { t } = useTranslation();

  return (
    <Badge
      pill
      className="fs-14 fw-400 py-2 px-4 text-dark"
      style={{ backgroundColor: isActive ? '#CEF0DA' : '#CCCCCC' }}
    >
      {t(`${dictPrefix}.${isActive ? 'active' : 'inactive'}`)}
    </Badge>
  );
}
